import React, { useState } from "react";
import analyticalProducts from "../../data/AnalyticalData";
import "./Analytical.css";

function AnalyticalPage() {
  const [activeId, setActiveId] = useState(null); // for highlighting a tile
  const [phoneModalSensor, setPhoneModalSensor] = useState(null); // show phone modal

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Analytical Instruments</h2>

      <div className="analytical-grid">
        {analyticalProducts.map((p) => (
          <div
            key={p.id}
            className={`analytical-card ${activeId === p.id ? "active" : ""}`}
            onClick={() => setActiveId(p.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setActiveId(p.id);
            }}
          >
            <div className="analytical-icon-wrap">
              {/* large image display — any uploaded image will fit nicely */}
              <img src={p.image} alt={p.name} className="analytical-icon" />
            </div>

            <div className="analytical-label">{p.name}</div>

            <div className="analytical-actions">
              <button
                className="btn btn-sm btn-price"
                onClick={(ev) => {
                  ev.stopPropagation();
                  setPhoneModalSensor(p);
                }}
              >
                Price
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Built-in phone modal */}
      {phoneModalSensor && (
        <div
          className="phone-modal-overlay"
          onClick={() => setPhoneModalSensor(null)}
          role="presentation"
        >
          <div
            className="phone-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Contact phone"
          >
            <h4>{phoneModalSensor.name}</h4>
            <p className="phone-modal-text">
              For price & enquiries, please call us on{" "}
              <a href="tel:+918329287300" className="phone-link">
                +91-8329287300
              </a>
            </p>

            <div className="phone-modal-actions">
              <button
                className="btn btn-sm btn-close"
                onClick={() => setPhoneModalSensor(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AnalyticalPage;
